import React, { Fragment } from 'react';
import styled from 'styled-components';
import Title from '../forms/Title';
import Tabbed from './Tabbed';
import Icon from '../forms/Icon';
import { useGlobalState } from '../stateProvider/StateProvider';
import Row from './Row';
import PageBreak from './PageBreak';
import HelpDesk from '../HelpDesk';
import Seasonal from '../Seasonal';
import { SCREEN_MAX_WIDTH, SCREEN_WIDTH } from '../../constants/config';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;

    // height: ${({ cutHeight }) => cutHeight ? 'calc(100% - 2.67em)' : 'auto'};
    height: auto;
    // min-height: calc(100% - 2.67em);

    gap: 0.5em;

    padding-bottom: 1em;

    animation: fadeIn;
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
`;
const FavIcon = styled(Icon)`
    color: ${({ fav, theme }) => fav ? theme.secondary : theme.white};
    opacity: ${({ fav }) => fav ? 1 : 0.2};
    transition: all 0.2s;
    user-select: none;
    cursor: pointer;

    @media (max-width: ${SCREEN_MAX_WIDTH}) {
        display: none;
    }
`;
const PageTitle = styled(Title)`
    position: sticky;
    top: 0;
    margin-bottom: 0.5em;
    display: flex;
    padding: 0em 0 1em 0;
    width: 100%;
    // border-bottom: 1px solid ${({ theme }) => theme.gray}40;
    color: ${({ theme }) => theme.white};
    align-items: center;
    z-index: 5;
    background: ${({ theme }) => theme.background};

    @media (max-width: ${SCREEN_MAX_WIDTH}) {
        background: unset;
    }
`;
const Controls = styled(Row)`
    font-size: 0.7em;
`
const Underlay = styled.div`
    position: absolute;
    height: calc(100% + 0.5em);
    width: calc(100% + 3em);
    left: calc(0px - 1.5em);
    top: -0.7em;
    background: ${({ theme }) => theme.primary};
    border-bottom: 3px solid ${({ theme }) => theme.tertiary};
    z-index: -1;
`
const Page = ({ children, ...props }) => {
    const {
        state: {
            quick_menu,
        },
        updateQuickMenu,
    } = useGlobalState();

    document.title = (props.tabTitle || props.title) ?? 'Hosted Solutions'

    return (
        <Wrapper cutHeight={props.title}>
            {props.title && (
                <PageTitle icon={props.icon}>
                    <Underlay>
                        <Seasonal />
                    </Underlay>
                    <Row style={{ flex: 1, justifyContent: 'space-between' }}>
                        <Row>
                            <span>{props.title}</span>
                            <HelpDesk HSpage={props.HSpage} />
                            <FavIcon
                                fav={quick_menu.find(e => e.route === window.location.pathname)}
                                onClick={() => updateQuickMenu(window.location.pathname, props.title, quick_menu)}
                                icon='star'
                            />
                        </Row>
                            <Controls>
                                {props.controls instanceof Array ? props.controls.map((e, i) => <Fragment key={`${i}-pageControls`}>{e}</Fragment>) : props.controls}
                            </Controls>
                    </Row>
                </PageTitle>
            )}
            {props.tabs ? <Tabbed {...props}>{children}</Tabbed> : props.pageBreak ? <PageBreak>{children}</PageBreak> : children}
        </Wrapper>
    );
}

export default Page;
